/**
 * Check if the screen is retina/high resolution.
 *
 * @return {Boolean}
 */
export default () => (
  (
    (
      // Should support match media
      window.matchMedia

      // && it should have a pixel ratio of 2 or hi-res
      && (
        window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches
        || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches
      )
    )
    // Optionally look at the window device pixel ratio
    || (window.devicePixelRatio && window.devicePixelRatio >= 2)
  )
);
